
import { TextFields } from "@material-ui/icons";
import { LocalizationProvider } from '@mui/x-date-pickers'
import { DateRange } from '@mui/x-date-pickers-pro';
import { TextField } from '@mui/material';
import AdapterJalali from '@date-io/date-fns-jalali';

import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';
import { Dayjs } from 'dayjs';
import '../style.scss'



import React, { useEffect, useState } from "react";
import { DrowpDown } from "../../../assets/images/svg/icon";
import { persianToEnglishChar } from "../../../shared/helper";

type Params = {
    maxCount: number,
    minCount: number,
    fromDate: string,
    toDate: string,
    lineStatus: number,
    phoneNumber: string,
    pageNumber: string,
    pageSize: string
}

type Props = {
    setParams: Function,
    params: Params,
    getData: Function
}




const SearchFilter = ({
    setParams,
    params,
    getData
}: Props) => {

    const [value, setValue] = useState<DateRange<Dayjs>>([null, null]);

    useEffect(() => {
        if (value[0]) {
            setParams({
                fromDate: value[0]
            })
        }
        else {
            setParams({
                fromDate: ''
            })
        }

        if (value[1]) {
            setParams({
                toDate: value[1]
            })
        }
        else {
            setParams({
                toDate: ''
            })
        }

    }, [value])

    return (
        <div className="d-flex justify-content-start align-items-center search-wrapper">
            <div className="date-picker-rangr-wrapper">
                <LocalizationProvider
                    dateAdapter={AdapterJalali}
                    localeText={{ start: 'ازتاریخ', end: 'تا تاریخ' }}
                >
                    <DateRangePicker
                        startText="از تاریخ"
                        endText="تا تاریخ"
                        value={value}
                        onChange={(newValue: any) => {
                            setValue(newValue);
                        }}
                        renderInput={(startProps: any, endProps: any) => (
                            <React.Fragment>
                                <TextField {...startProps} />
                                <span style={{ margin: '0px 10px' }}>تا</span>
                                {/* <DateRangeDelimiter> to </DateRangeDelimiter>  */}
                                <TextField {...endProps} />
                            </React.Fragment>
                        )}
                    />
                </LocalizationProvider>
            </div>
            <div className="d-flex justify-content-between align-items-center max-min-input">
                <input
                    type="number"
                    placeholder="حداقل تعداد تماس"
                    name="min-count"
                    autoComplete="off"
                    min="0"
                    max="9999"
                    onChange={(e: any) => { setParams({ minCount: e.target.value,pageNumber:1 }) }}
                    value={params.minCount}

                />
                <input
                    type="number"
                    placeholder="حداکثر تعداد تماس"
                    name="max-count"
                    autoComplete="off"
                    min="0"
                    max="9999"
                    onChange={(e: any) => { setParams({ maxCount: e.target.value,pageNumber:1 }) }}
                    value={params.maxCount}
                />
            </div>


            <div>
                <input
                    className="form-control phone-input"
                    type="text"
                    placeholder="شماره تلفن خود را وارد نمایید"
                    onChange={(e: any) => setParams({ phoneNumber: persianToEnglishChar((e.target.value).trim()) ,pageNumber:1})}
                    value={params.phoneNumber} />

            </div>

            <div className="select-wrapper">
                <select
                    className="form-control select-line-status"
                    onChange={(e: any) => setParams({ lineStatus: e.target.value ,pageNumber:1})}
                    value={params.lineStatus}
                >
                    <option value="all">همه</option>
                    <option value="Available">در حال نمایش</option>
                    <option value="WaitToActive">در انتظار آزادسازی</option>
                    <option value="NotforSale">غیر قابل فروش</option>
                    <option value="Parked">معلق</option>
                    <option value="InUse">در حال استفاده</option>
                    <option value="Reserved">رزرو شده</option>

                </select>
                <span className="icon-selector-invoice-holder"><DrowpDown /></span>
            </div>



            <button
                onClick={() => { getData() }}
                className="btn btn-primary mx-5">
                جستجو
            </button>
        </div>
    )
}

export default SearchFilter